<template>
  <div v-if="showCurrentPrice">
    <div class="d-flex justify-content-between align-items-center">
      <span>
        {{ I18n.t("internet_auctions.current_price") }}
      </span>
      <span class="price price--highlight m-0">
        {{ I18n.t("artworks.price", { price: formatPrice(internetAuction.value) }) }}
      </span>
    </div>
    <div class="d-flex justify-content-between mt-2 position-relative internet-modal__transitions--height">
      <small>
        {{ I18n.t("internet_auctions.auction.offers", { count: internetAuction.bidsCount }) }}
      </small>
      <transition name="fade">
        <span
          v-if="isUserLastBidder"
          class="internet_auction-winning price--highlight position-absolute"
        >
          {{ I18n.t("artworks.you_lead") }}
        </span>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { formatNumber } from '@/shared/helpers';
  import { AUCTION_STARTED_STATE } from '@/internet_auctions/consts';

  export default {
    name: 'AuctionValue',
    props: {
      internetAuction: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        formatPrice: formatNumber,
        auctionStartedState: AUCTION_STARTED_STATE,
      };
    },
    computed: {
      ...mapState([
        'userId',
        'entities',
        'activeModalAuctionId',
      ]),
      auctionStateIsStarted() {
        return this.internetAuction.state === this.auctionStartedState;
      },
      showCurrentPrice() {
        return (this.internetAuction.bidsCount > 0 && this.auctionStateIsStarted);
      },
      isUserLastBidder() {
        return this.internetAuction.lastBidUserId === this.userId;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/internet_auctions/components/modal/auction_value.vue?148d1f7e